/**
 * Shows a placeholder text (via CSS ::before, see styles/default.scss) while
 * the document is empty and the editor is editable.
 */
import { Node } from "prosemirror-model";
import { Plugin } from "prosemirror-state";
import { Decoration, DecorationSet } from "prosemirror-view";

const isDocEmpty = (doc: Node) =>
    doc.childCount === 1 &&
    doc.firstChild!.isTextblock &&
    doc.firstChild!.content.size === 0;

export const placeholderPlugin = (placeholder: string) =>
    new Plugin({
        props: {
            decorations(state) {
                if (!isDocEmpty(state.doc)) {
                    return null;
                }
                return DecorationSet.create(state.doc, [
                    Decoration.node(0, state.doc.firstChild!.nodeSize, {
                        "class": "editor-placeholder",
                        "data-placeholder": placeholder,
                    }),
                ]);
            },
        },
    });
